export default "__VITE_ASSET__9igBolAV__"